import { render, staticRenderFns } from "./addNotes.vue?vue&type=template&id=4147cf71"
import script from "./addNotes.vue?vue&type=script&lang=js"
export * from "./addNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports